import React from "react";
import curly from "../../images/curly.png";
import { ReactComponent as CheckSvg } from "../../svgs/check.svg";
import { ReactComponent as PlayStoreSvg } from "../../svgs/PlayStore.svg";
import { Link } from "react-router-dom";
import { PLAYSTORE_URL } from "../../constants";
import { useAuth } from "../../helper/auth";
import { routes } from "../../helper/misc";

function Hero() {
  const { meterOwnerships } = useAuth();
  const linkToGoTo = () => {
    if (meterOwnerships.length > 0) {
      return routes.buy_water;
    }
    return routes.manage_meters;
  };
  return (
    <section className="max-w-[1280px] px-4 md:px-10 mx-auto">
      <span className="hidden md:hidden lg:block w-16 absolute top-[8%] left-[35%]">
        <img src={curly} alt="" />
      </span>
      {/* buy water anywhere */}
      <div className="flex flex-col space-y-10 lg:space-y-0 lg:space-x-[120px] lg:flex-row my-10 lg:my-[100px]">
        <div className="flex flex-col">
          <h4 className="text-3xl font-extrabold text-left md:self-start lg:text-5xl lg:leading-[60px] lg:w-[646px]">
            Buy your water credit anytime anywhere with{" "}
            <span className="text-pw-blue">PayWater</span>
          </h4>
          <div className="flex mt-6 md:mt-12 flex-col space-y-5 md:flex-row md:space-x-5 md:space-y-0">
            <Link to={linkToGoTo()}>
              <button className="text-white bg-pw-blue py-[15px] px-[37px] rounded-3xl hover:text-pw-blue hover:bg-white border-2 transition-all duration-500 hover:border-pw-blue">
                Get Started
              </button>
            </Link>
            <Link to="/report-leakage">
              <button className="text-pw-blue bg-white py-[15px] px-[23px] rounded-3xl border-2 border-pw-blue hover:bg-pw-blue transition-all duration-500 hover:text-white">
                Report Leakage
              </button>
            </Link>
          </div>
        </div>
        <div className="mb-8">
          <h4 className="font-extrabold text-3xl">Download Our App</h4>
          <h6 className="my-4 text-[22px] font-medium">Benefits</h6>
          <ul className="textpw-grey text-[17px]">
            <li className="flex items-center mb-4">
              <span className="mr-2">
                <CheckSvg />
              </span>
              Save your Payment Details
            </li>
            <li className="textpw-grey flex items-center mb-4">
              <span className="mr-2">
                <CheckSvg />
              </span>
              Get free water after watching ads
            </li>
            <li className="textpw-grey flex items-center mb-4">
              <span className="mr-2">
                <CheckSvg />
              </span>
              Track your water consumption
            </li>
            <li className="textpw-grey flex items-center">
              <span className="mr-2">
                <CheckSvg />
              </span>
              And lots more
            </li>
          </ul>
          <div className="flex flex-col mt-10 md:flex-row lg:flex-row">
            {/* <button
              onClick={() => toast("Coming soon!")}
              className="mb-4 mr-2 md:mb-0 lg:mb-0 cursor-pointer"
            >
              <AppStoreSvg />
            </button> */}
            <a
              href={PLAYSTORE_URL}
              rel="noreferrer"
              target="_blank"
              className="cursor-pointer"
            >
              <PlayStoreSvg />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
